import React from 'react';
import classNames from 'classnames';
import { BadgeProps } from './Badge.types';

/**
 * Badge component that displays short status information
 * Follows the design system with consistent colors and styling
 */
export const Badge = ({
  label,
  variant = 'default',
  size = 'md',
  className,
}: BadgeProps): React.ReactElement => {
  // Define variant styles based on our design system colors
  const variantStyles = {
    success: 'bg-success text-white',
    warning: 'bg-warning text-white',
    error: 'bg-error text-white',
    info: 'bg-info text-white',
    primary: 'bg-primary-50 text-primary-100',
    default: 'bg-gray-200 dark:bg-slate-700 text-gray-700 dark:text-gray-200',
  };

  // Define size styles
  const sizeStyles = {
    sm: 'px-1.5 py-0.5 text-xs',
    md: 'px-2 py-1 text-xs',
    lg: 'px-3 py-1.5 text-sm',
  };
  
  return (
    <span 
      className={classNames(
        'inline-flex items-center justify-center font-medium rounded-full',
        variantStyles[variant],
        sizeStyles[size],
        className,
      )}
    >
      {label}
    </span>
  );
};

export default Badge;